module.exports = __webpack_public_path__ + "static/media/whatsapp.71e29a97.png";